@if (energyRating(); as rating) {
    <div class="energy-rating">
        <div class="energy-rating__title">
            <div class="energy-rating__title__container">
                <div class="icon" [ngClass]="{ 'alert': energyRatingSummary().all, 'hide': !rating.hasExpiredEnergyLabel }"></div>
                <div class="title">Energimerke</div>
            </div>
            <div class="energy-rating__title__description">{{ rating.energyLabelPercentageShare | number: '1.0-1' }}% av andeler</div>
        </div>
        <div class="energy-rating__data">
            <div class="wrapper">
                @if (energyRatingSummary().all) {
                    <div class="left">
                        <div class="item first">&nbsp;{{ rating.energyLabelMin }} {{ rating.energyLabelColorMin }}</div>
                        <div class="item"><div class="three-dot"></div></div>
                        <div class="item">Median
                            <div class="item-value"> {{ rating.energyLabelMedian }} {{ rating.energyLabelColorMedian }}</div>
                        </div>
                        <div class="item"><div class="three-dot"></div></div>
                        <div class="item last">&nbsp;{{ rating.energyLabelMax }} {{ rating.energyLabelColorMax }}</div>
                    </div>
                } @else {
                    <div class="left">
                        <div class="item">Ukjent</div>
                    </div>
                }

                @if (energyRatingSummary().all) {
                    <div class="right">
                        <div class="value-description">
                            @if (energyRatingSummary().min) {
                                <div class="energy-label-icon" [ngClass]="rating.energyColorClassMin" [class.expired]="rating.energyLabelsIsExpired"></div>
                            } @else {
                                <div class="energy-label-icon unknown"></div>
                            }
                        </div>
                        <div class="value-description">
                            @if (energyRatingSummary().median) {
                                <div class="energy-label-icon" [ngClass]="rating.energyColorClassMedian" [class.expired]="rating.energyLabelsIsExpired"></div>
                            } @else {
                                <div class="energy-label-icon unknown"></div>
                            }
                        </div>
                        <div class="value-description">
                            @if (energyRatingSummary().max) {
                                <div class="energy-label-icon" [ngClass]="rating.energyColorClassMax" [class.expired]="rating.energyLabelsIsExpired"></div>
                            } @else {
                                <div class="energy-label-icon unknown"></div>
                            }
                        </div>
                    </div>
                } @else {
                    <div class="right">
                        <div class="value-description">
                            <div class="energy-label-icon unknown"></div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}

